import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Box,
  Modal
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";

// import {
//   CompanyDropDown,
//   doseDropDown,
//   genericDropDown,
//   itemCategoryDropDownMaster,
//   itemTypeDropDownMaster,
//   postitem,
//   purchaseUOMDropDown,
//   routeDropDown,
// } from "../../../../services/Item/ItemService";
// import {
//   itemClassDropdown
// } from "../../../../services/Supplier/SupplierService";

import {CompanyDropDown,  doseDropDown,
  genericDropDown,
  itemCategoryDropDownMaster,
  itemTypeDropDownMaster,
  postitem,
  purchaseUOMDropDown,
  routeDropDown,
} from "../../../services/inventory/item/ItemMasterServices"
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import InputField from "../../../../common/components/FormFields/InputField";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import SearchDropdown from "../../clinical/nursingcareplan/searchDropdown";
import RadioField from "../../../../common/components/FormFields/RadioField";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import { errorAlert, successAlert } from "../../../../common/components/Toasts/CustomToasts";
import { itemClassDropdown } from "../../../services/inventory/supplier/SupplierService";
export const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: "90%",
  // height:"90%",
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "1px solid gray",
  borderRadius: 1,
  boxShadow: 20,
  "&::-webkit-scrollbar": {
    width: 7,
    height: 10,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "lightBlue",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#1e3a8a",
  },
};
const OncoType = [
  {
    id: "onco",
    label: "Onco",
    value: "onco",
  },
  {
    id: "nonOnco",
    label: "Non Onco",
    value: "nonOnco",
  },
];

const chargeType = [
  {
    id: "chargeable",
    label: "Chargeable",
    value: "chargeable",
  },
  {
    id: "nonChargeable",
    label: "Non Chargeable",
    value: "nonChargeable",
  },
  {
    id: "both",
    label: "Both",
    value: "Both",
  },
];

const antibioticsType = [
  {
    id: "highendAntibiotics",
    label: "High-end Antibiotics  ",
    value: "highendAntibiotics",
  },
  {
    id: "antibiotics",
    label: "Antibiotics",
    value: "antibiotics",
  },
  {
    id: "none",
    label: "None",
    value: "none",
  },
];

const alphabetType = [
  {
    id: "a",
    label: "A",
    value: "a",
  },
  {
    id: "b",
    label: "B",
    value: "b",
  },
  {
    id: "c",
    label: "C",
    value: "c",
  },
];
const alphabetTypeVED = [
  {
    id: "v",
    label: "V",
    value: "v",
  },
  {
    id: "e",
    label: "E",
    value: "e",
  },
  {
    id: "d",
    label: "D",
    value: "d",
  },
];
const alphabetTypeXYZ = [
  {
    id: "x",
    label: "X",
    value: "x",
  },
  {
    id: "y",
    label: "Y",
    value: "y",
  },
  {
    id: "z",
    label: "Z",
    value: "z",
  },
];
export default function ItemModel(props) {
  const defaultValues = {
    status: true,
    itemCode: "",
    itemName: "",
    itemShortName: "",
    itemType: null,
    itemCatgory: null,
    itemClass: null,
    generic: null,
    stockingUOM: null,
    mfgCompany: null,
    mrkCompany: null,
    purchaseRate: "",
    itemForm: null,
    conversionFactor: "",
    reorder: "",
    concession: "",
    frequency: null,
    route: null,
    HSNCode: "",
    strength: "",
    strengthKg: "",
    percentage: "",
    pediatricStrength: "",
    pediatricStrengths: null,
    adultStrength: "",
    adultStrengths: null,
    GST: "",
    Onco: "onco",
    charge: "chargeable",
    alphabet: "a",
    alphabetVED: "v",
    alphabetXYZ: "x",
    isFixedAsset: false,
    freeApplicable: false,
    isCSSD: false,
    isConcessionApplicable: false,
    isCulture: false,
    isGeneric: false,
    barcodePrint: false,
    inclusive: false,
    charge: "chargeable",
    antibiotics: "highendAntibiotics",
  };
  const {
    control,
    handleSubmit,
    watch,
    register,
    setValue,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    // resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });
  const [itemTypeOption, setItemTypeOption] = useState([]);
  const [itemId, setIemTypeId] = useState(null)
  const [itemCategoryOption, setItemCategoryOption] = useState([]);
  const [itemClassOption, setItemClassOption] = useState([]);
  const [itemOption, setItemOption] = useState([]);
  const [genericOption, setGenericoption] = useState([]);
  const [uomOption, setUomOption] = useState([]);
  const [routeOption, setRouteOption] = useState([]);
  const [mfgComOption, setMfgComOption] = useState([]);
  const [doseOption, setDoseOption] = useState([]);
  const [itemFromOption, setItemFromOption] = useState([]);
  const [finalData, setFinalData] = React.useState();
  const [openPost, setOpenPost] = React.useState(false);
  const [openPut, setOpenPut] = React.useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleClosePost = () => {
    if (openPost) {
      setOpenPost(false);
    }
  };

  const handleClosePut = () => {
    if (openPut) {
      setOpenPut(false);
    }
  };
  function itemTypeDropdownApi() {
    itemTypeDropDownMaster().then((response) => {
      setItemTypeOption(response.data.result);
    });
  }
  function itemCategoryDropdownApi() {
    if (itemId !== null) {
      itemCategoryDropDownMaster(itemId).then((response) => {
        setItemCategoryOption(response.data.result);
      });
    }
  }
  function itemClassDropdownApi() {
    itemClassDropdown().then((response) => {
      setItemClassOption(response.data.result);
    });
  }
  function purchaseUOMDropdownApi() {
    purchaseUOMDropDown().then((response) => {
      setUomOption(response.data.result);
    });
  }

  function companyDropdownApi() {
    CompanyDropDown().then((response) => {
      setMfgComOption(response.data.result);
    });
  }
  function routeDropdownApi() {
    routeDropDown().then((response) => {
      setRouteOption(response.data.result);
    });
  }
  function doseDropdownApi() {
    doseDropDown().then((response) => {
      setDoseOption(response.data.result);
    });
  }

  //Autosearch API Function
  const handleChange = (autoSearchString) => {
    autoSearchString &&
      genericDropDown(autoSearchString)
        .then((response) => response.data)
        .then((res) => {
          console.log("res", res.result);
          setGenericoption(res.result);
        });
  };
  useEffect(() => {
    purchaseUOMDropdownApi();
    itemTypeDropdownApi();
    itemCategoryDropdownApi(itemId);
    itemClassDropdownApi();
    companyDropdownApi();
    routeDropdownApi();
    doseDropdownApi();
  }, [itemId]);

  let isCultureWatch = watch("isCulture");
  let isCulctureValue;

  if (isCultureWatch === true) {
    isCulctureValue = 1;
  } else {
    isCulctureValue = 0;
  }

  let antibioticsWatch = watch("antibiotics");
  let antibioticsValue;
  if (antibioticsWatch === "highendAntibiotics") {
    antibioticsValue = 1;
  } else if (antibioticsWatch === "antibiotics") {
    antibioticsValue = 2;
  } else {
    antibioticsValue = 0;
  }

  let OncoWatch = watch("Onco");
  let OncoValue;
  if (OncoWatch === "onco") {
    OncoValue = "1";
  } else if (OncoWatch === "nonOnco") {
    OncoValue = "2";
  }

  let isFixedAssetWatch = watch("isFixedAsset");
  // let isFixedAssetValue;

  // if (isFixedAssetWatch === true) {
  //   isFixedAssetValue = 0;
  // } else {
  //   isFixedAssetValue = 1;
  // }
  let isGenericWatch = watch("isGeneric");

  let isFixedAssetValue = isFixedAssetWatch ? 1 : 0;
  let isGenericValue = isGenericWatch ? 1 : 0;
  let chargeWatch = watch("charge");
  let chargeValue;
  // if (chargeWatch === "chargeable") {
  //   chargeValue = "0";
  // } else if (chargeWatch === "nonChargeable") {
  //   chargeValue = "1";
  // } else if (chargeWatch === "both") {
  //   chargeValue = "2";
  // }

  if (chargeWatch === "chargeable") {
    chargeValue = "1";
  } else if (chargeWatch === "nonChargeable") {
    chargeValue = "2";
  } else {
    chargeValue = "3";
  }

  // let isGenericWatch = watch("isGeneric");
  // let isGenericValue;

  // if (isGenericWatch === true) {
  //   isGenericValue = 0;
  // } else {
  //   isGenericValue = 1;
  // }
  const onSubmitDataHandler = (data) => {
    if (props.edit === false) {
      let objPost = {
        concessionper: 100,
        ped_strength: data.pediatricStrength,
        ped_strength_unit: "string",
        adult_strength: data.adultStrength,
        adult_strength_unit: "string",
        isbarcodeprint: data.barcodePrint,
        id: 0,
        description: data.itemName,
        shortDescription: data.itemShortName,
        status: data.status,
        addedBy: 154,
        updatedBy: 154,
        code: data.itemCode,
        genericDescription: "string",
        packagingMaterialId: 0,
        isPackagingMaterial: 0,
        itemMarketedById: 0,
        isReusablePackagingMaterial: true,
        chargeableNonChargeable: chargeValue,
        isGenericMedicine: isGenericValue,
        itemType: data.itemType !== null ? data.itemType?.id : 0,
        itemCategory: data.itemCatgory !== null ? data.itemCatgory?.id : 0,
        itemClass: data.itemClass !== null ? data.itemClass?.id : 0,
        itemGenericId: data.generic !== null ? data.generic?.id : 0,
        itemCompanyId: data.mfgCompany?.id,
        purchaseUOM: data.purchaseUOM?.id,
        consignment: true,
        cssditemType: 0,
        concessionApp: data.isConcessionApplicable,
        balanceQty: 0,
        // ved: data.alphabetVED,
        currencyId: 0,
        batchesRequired: true,
        // abc: data.alphabet,
        conversion:
          data.conversionFactor !== "" ? Number(data.conversionFactor) : 0,
        freeApplicable: data.freeApplicable,
        routeId: data.route?.id,
        printFlag: true,
        staffDD: true,
        gst: data.GST !== "" ? Number(data.GST) : 0,
        dose: data.frequency?.label,
        mrp: 0,
        // xyz: data.alphabetXYZ,
        abc:
          data.alphabet === "a" ? 0 :
            data.alphabet === "b" ? 1 : 2,

        ved:
          data.alphabetVED === "v" ? 0 :
            data.alphabetVED === "e" ? 1 : 2,

        xyz:
          data.alphabetXYZ === "x" ? 0 :
            data.alphabetXYZ === "y" ? 1 : 2,
        stockingUOM: data.stockingUOM?.id,
        isCssdItem: data.isCSSD,
        isConsumable: 0,
        // isFixedAsset: data.isFixedAssetValue,
        isFixedAsset: isFixedAssetValue,
        oncoDist: data.percentage,
        octroi: 0,
        reOrder: data.reorder,
        staffPDD: true,
        oncoOrNonOnco: OncoValue,
        purchaseRate: data.purchaseRate !== "" ? Number(data.purchaseRate) : 0,
        inclusive: data.inclusive,
        doseId: data.frequency?.id,
        isCulture: isCulctureValue,
        antibioticType: antibioticsValue,
        drugCatID: 0,
        hsncode: data.HSNCode,
        strengthPerKg: data.strengthKg,
        strength: data.strength,
      };
      console.log("is data save object", objPost);
      setOpenPost(true);
      setFinalData(objPost);
    }
    if (props.edit === true) {
      let objPut = {
        id: props.editdatafetch.id,
        concessionper: 100,
        ped_strength: data.pediatricStrength,
        ped_strength_unit: "string",
        adult_strength: data.adultStrength,
        adult_strength_unit: "string",
        isbarcodeprint: data.barcodePrint,
        description: data.itemName,
        shortDescription: data.itemShortName,
        status: data.status,
        addedBy: 154,
        updatedBy: 154,
        code: data.itemCode,
        genericDescription: "string",
        packagingMaterialId: 0,
        isPackagingMaterial: 0,
        itemMarketedById: 0,
        isReusablePackagingMaterial: true,
        chargeableNonChargeable: chargeValue,
        isGenericMedicine: isGenericValue,
        itemType: data.itemType !== null ? data.itemType?.id : 0,
        itemCategory: data.itemCatgory !== null ? data.itemCatgory?.id : 0,
        itemClass: data.itemClass !== null ? data.itemClass?.id : 0,
        itemGenericId: data.generic !== null ? data.generic?.id : 0,
        itemCompanyId: data.mfgCompany?.id,
        purchaseUOM: data.purchaseUOM?.id,
        consignment: true,
        cssditemType: 0,
        concessionApp: data.isConcessionApplicable,
        balanceQty: 0,
        // ved: data.alphabetVED,
        currencyId: 0,
        batchesRequired: true,
        // abc: data.alphabet,
        conversion:
          data.conversionFactor !== "" ? Number(data.conversionFactor) : 0,
        freeApplicable: data.freeApplicable,
        routeId: data.route?.id,
        printFlag: true,
        staffDD: true,
        gst: data.GST !== "" ? Number(data.GST) : 0,
        dose: data.frequency?.label,
        mrp: 0,
        // xyz: data.alphabetXYZ,
        abc:
          data.alphabet === "a" ? 0 :
            data.alphabet === "b" ? 1 : 2,

        ved:
          data.alphabetVED === "v" ? 0 :
            data.alphabetVED === "e" ? 1 : 2,

        xyz:
          data.alphabetXYZ === "x" ? 0 :
            data.alphabetXYZ === "y" ? 1 : 2,
        stockingUOM: data.stockingUOM?.id,
        isCssdItem: data.isCSSD,
        isConsumable: 0,
        // isFixedAsset: data.isFixedAssetValue,
        isFixedAsset: isFixedAssetValue,
        oncoDist: data.percentage,
        octroi: 0,
        reOrder: data.reorder,
        staffPDD: true,
        oncoOrNonOnco: OncoValue,
        purchaseRate: data.purchaseRate !== "" ? Number(data.purchaseRate) : 0,
        inclusive: data.inclusive,
        doseId: data.frequency?.id,
        isCulture: isCulctureValue,
        antibioticType: antibioticsValue,
        drugCatID: 0,
        hsncode: data.HSNCode,
        strengthPerKg: data.strengthKg,
        strength: data.strength,
      };
      console.log("is data update object", objPut);
      setOpenPut(true);
      setFinalData(objPut);
    }
  };

  const fileRef = useRef();

  const handleAdd = () => {
    const description = watch("description");

    if (!description || !selectedFile) {
      alert("Enter description and select file");
      return;
    }

    const newRow = {
      description: description,
      fileName: selectedFile.name,
      file: selectedFile,
    };

    setTableData((prev) => [...prev, newRow]);

    // ✅ clear fields
    setValue("description", "");
    setSelectedFile(null);

    // 🔥 clear file input
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  };

  //Post / Add API Function
  function addRecord() {
    postitem(finalData)
      .then((response) => response.data)
      .then((res) => {
        successAlert(res.message);
        props.setOpen(false);
        props.setEdit(false);
        setOpenPost(false);
        setOpenPut(false);
        reset(defaultValues);
        setTableData([]);
        props.populateTable();
      })
      .catch((error) => {
        errorAlert(error.message);
      });
  }
  React.useEffect(() => {
    if (props.edit === true) {
      console.log("props.editdatafetch", props.editdatafetch);
      let ItemTypeObj = {
        id: props.editdatafetch.itemType,
        value: props.editdatafetch.itemType,
        label: props.editdatafetch.itemTypeDesc,
      };
      let ItemCategoryObj = {
        id: props.editdatafetch.itemCategoryId,
        value: props.editdatafetch.itemCategoryId,
        label: props.editdatafetch.itemCategoryDesc,
      };
      let ItemClassObj = {
        id: props.editdatafetch.itemClass,
        value: props.editdatafetch.itemClass,
        label: props.editdatafetch.itemClassDesc,
      };

      let genericObj = {
        id: props.editdatafetch.itemGenericId,
        value: props.editdatafetch.itemGenericId,
        label: props.editdatafetch.ItemGenericDesc,
      };

      let purchaseUOMObj = {
        id: props.editdatafetch.purchaseUOMId,
        value: props.editdatafetch.purchaseUOMId,
        label: props.editdatafetch.purchaseUOMDesc,
      };
      let stockingUOMObj = {
        id: props.editdatafetch.stockingUOMId,
        value: props.editdatafetch.stockingUOMId,
        label: props.editdatafetch.stockUOMDesc,
      };

      let mfgCompanyObj = {
        id: props.editdatafetch.itemCompanyId,
        value: props.editdatafetch.itemCompanyId,
        label: props.editdatafetch.ItemCompanyDesc,
      };

      let routeObj = {
        id: props.editdatafetch.routeId,
        value: props.editdatafetch.routeId,
        label: props.editdatafetch.routeDesc,
      };

      let frequencyObj = {
        id: props.editdatafetch.doseId,
        value: props.editdatafetch.doseId,
        label: props.editdatafetch.dose,
      };

      setValue("itemForm", ItemTypeObj);
      setValue("itemCode", props.editdatafetch.code);
      setValue("itemName", props.editdatafetch.description);
      setValue("itemShortName", props.editdatafetch.shortDescription);
      setValue("status", props.editdatafetch.status);
      { props.editdatafetch.itemType === 0 ? (setValue("itemType", null)) : (setValue("itemType", ItemTypeObj)) }
      { props.editdatafetch.itemCategoryId === 0 ? (setValue("itemCatgory", null)) : (setValue("itemCatgory", ItemCategoryObj)) }
      { props.editdatafetch.itemClass === 0 ? (setValue("itemClass", null)) : (setValue("itemClass", ItemClassObj)) }

      setValue("conversionFactor", props.editdatafetch.conversion);
      setValue("concession", props.editdatafetch.concessionper);
      // setValue("itemCatgory", ItemCategoryObj);
      // setValue("itemClass", ItemClassObj);
      setValue("purchaseUOM", purchaseUOMObj);
      setValue("stockingUOM", stockingUOMObj);
      setValue("mfgCompany", mfgCompanyObj);
      setValue("mrkCompany", mfgCompanyObj);
      setValue("purchaseRate", props.editdatafetch.purchaseRate);
      setValue("frequency", frequencyObj);
      setValue("route", routeObj);

      setValue("reorder", props.editdatafetch.reOrder);
      setValue("GST", props.editdatafetch.GST);
      setValue("HSNCode", props.editdatafetch.hsnCode);
      setValue("strength", props.editdatafetch.strength);
      setValue("strengthKg", props.editdatafetch.strengthPerKg);
      if (props.editdatafetch.onco === "1") {
        setValue("Onco", "onco");
      } else if (props.editdatafetch.onco === "2") {
        setValue("Onco", "nonOnco");
      }
      setValue("percentage", props.editdatafetch.oncoDist);
      setValue("pediatricStrength", props.editdatafetch.pedStrength);
      setValue("adultStrength", props.editdatafetch.adultStrength);
      if (props.editdatafetch.abc === "0") {
        setValue("alphabet", "a");
      } else if (props.editdatafetch.abc === "1") {
        setValue("alphabet", "b");
      } else if (props.editdatafetch.abc === "2") {
        setValue("alphabet", "c");
      }
      if (props.editdatafetch.ved === "0") {
        setValue("alphabetVED", "v");
      } else if (props.editdatafetch.ved === "1") {
        setValue("alphabetVED", "e");
      } else if (props.editdatafetch.ved === "2") {
        setValue("alphabetVED", "d");
      }
      if (props.editdatafetch.xyz === "0") {
        setValue("alphabetXYZ", "x");
      } else if (props.editdatafetch.xyz === "1") {
        setValue("alphabetXYZ", "y");
      } else if (props.editdatafetch.xyz === "2") {
        setValue("alphabetXYZ", "z");
      }

      // ✅ Charge mapping
      if (props.editdatafetch.chargeableNonChargeable === "1") {
        setValue("charge", "chargeable");
      } else if (props.editdatafetch.chargeableNonChargeable === "2") {
        setValue("charge", "nonChargeable");
      } else {
        setValue("charge", "both");
      }

      // ✅ Antibiotics mapping
      if (props.editdatafetch.antibioticType === 1) {
        setValue("antibiotics", "highendAntibiotics");
      } else if (props.editdatafetch.antibioticType === 2) {
        setValue("antibiotics", "antibiotics");
      } else {
        setValue("antibiotics", "none");
      }

      setValue("generic", genericObj);
      setGenericoption((prev) => [genericObj, ...prev]);
      setValue("isFixedAsset", props.editdatafetch.isFixedAsset);
      setValue("freeApplicable", props.editdatafetch.freeApplicable);
      setValue("isCSSD", props.editdatafetch.isCssdItem);
      // setValue("isCulture", props.editdatafetch.isCulture);
      setValue("isConcessionApplicable", props.editdatafetch.concessionApp);
      // setValue("isGeneric", props.editdatafetch.isGenericMedicine);
      setValue("isCulture", Boolean(props.editdatafetch.isCulture));
      setValue("isGeneric", Boolean(props.editdatafetch.isGenericMedicine));
      setValue("barcodePrint", props.editdatafetch.isBarcodePrint);
      setValue("inclusive", props.editdatafetch.inclusive);
      //   setValue("charge", props.editdatafetch.isTriplicate);
      //   setValue("antibiotics", props.editdatafetch.isTriplicate);

      //   if (props.editdatafetch.ScheduleH1 === 0) {

      //   setValue("radio","ScheduleH1");
      // }
      //   if (props.editdatafetch.xSchedule === true) {

      //     setValue("radio", "ScheduleX");
      //   }
      //   if (props.editdatafetch.hSchedule === true) {

      //     setValue("radio", "ScheduleH");
      //   }
    }
  }, [props.editdatafetch]);
  return (
    <div>
      {" "}
      <Modal
        open={props.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle} className="h-[80%] w-[90%]"

        >
          <CancelPresentationIconButton
            onClick={() => {
              reset(defaultValues);
              props.handleClose();
              //   props.setEdit(false);
            }}
          />

          <form onSubmit={handleSubmit(onSubmitDataHandler)}>
            <fieldset className=" text-left  py-2 rounded mt-1  p-3">
              <legend className=" px-2 ml-3 lg:ml-0  text-gray-800 text-[18px] font-semibold text-start py-2 ">
                Item Master
              </legend>

              <div className="">
                <div>
                  <fieldset>
                    <div className="w-full my-1">
                      <Accordion
                        className="px-2"
                        sx={{
                          "& .MuiAccordionSummary-root": {
                            padding: "0px",
                            // marginBottom: "-1rem",
                          },

                          "& .MuiAccordionDetails-root": {
                            padding: "0px",
                          },
                          boxShadow: 1,
                        }}
                        defaultExpanded={true}
                      >
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          expandIcon={
                            <ExpandMoreIcon
                            // sx={{
                            //   background: "#0B83A5",
                            //   margin: "5px 0",
                            //   color: "white",
                            //   minHeight: 0,
                            // }}
                            />
                          }
                          sx={{
                            "&.Mui-expanded": {
                              minHeight: 1,
                            },
                            "& .MuiAccordionSummary-content.Mui-expanded": {
                              margin: "auto",
                            },
                            "&.expanded": {
                              margin: "0px",
                            },
                          }}
                        >
                          <p className="text-start text-[16px] font-semibold pt-2 ">
                            Item info
                          </p>
                        </AccordionSummary>
                        <div className="grid grid-cols-4 lg:grid-cols-4 gap-3 mb-2">
                          <div>
                            <InputField
                              maxLength={10}
                              control={control}
                              name="itemCode"
                              label="Item Code*"
                            />
                          </div>
                          <div>
                            <InputField
                              maxLength={100}
                              control={control}
                              name="itemName"
                              label="Item Name*"
                            />
                          </div>
                          <div>
                            <InputField
                              maxLength={100}
                              control={control}
                              name="itemShortName"
                              label="Item Short Name*"
                            />
                          </div>
                          <div>
                            <CheckBoxField
                              control={control}
                              label="Active"
                              name="status"
                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="itemType"
                              placeholder="Item Type *"
                              dataArray={itemTypeOption}
                              inputRef={{
                                ...register("itemType", {
                                  onChange: (e) => {
                                    setIemTypeId(e.target.value.id);
                                    console.log("itemType", e.target.value.id);
                                  },
                                }),
                              }}
                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="itemCatgory"
                              placeholder="Item Category *"
                              dataArray={itemCategoryOption}
                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="itemClass"
                              placeholder="Item Class *"
                              dataArray={itemClassOption}
                            />
                          </div>
                          <div>
                            <SearchDropdown
                              control={control}
                              name="generic"
                              placeholder="Generic"
                              searchIcon={true}
                              handleInputChange={handleChange}
                              dataArray={genericOption}
                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="purchaseUOM"
                              placeholder="Purchase UOM.*"
                              dataArray={uomOption}

                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="stockingUOM"
                              placeholder="Stocking UOM.*"
                              dataArray={uomOption}
                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="mfgCompany"
                              placeholder="Mfg. Company *"
                              dataArray={mfgComOption}
                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="mrkCompany"
                              placeholder="Mrk. Company *"
                              dataArray={mfgComOption}
                            />
                          </div>
                          <div className="grid grid-cols-2 gap-2">
                            <div>
                              <InputField
                                control={control}
                                name="purchaseRate"
                                label="Purchase Rate"
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="itemForm"
                                placeholder="Item Form"
                                dataArray={itemTypeOption}
                              />
                            </div>
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="conversionFactor"
                              label="Conversion Factor *"
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="reorder"
                              label="Reorder"
                            />
                          </div>
                          <div className="flex gap-2">
                            <div>
                              <InputField
                                type="number"
                                control={control}
                                name="GST"
                                label="GST (%)"
                              />
                            </div>
                            <div>
                              <InputField
                                control={control}
                                name="concession"
                                label="Concession (%)"
                              />
                            </div>
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="frequency"
                              placeholder="Frequency"
                              dataArray={doseOption}
                            />
                          </div>
                          <div>
                            <DropdownField
                              control={control}
                              name="route"
                              placeholder="Route"
                              dataArray={routeOption}
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="HSNCode"
                              label="HSN Code"
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="strength"
                              label="Strength"
                            />
                          </div>
                          <div>
                            <InputField
                              control={control}
                              name="strengthKg"
                              label="Strength / Kg "
                            />
                          </div>
                          <div className="flex lg:col-span-1 md:col-span-2 gap-4">
                            <div className="mt-2">
                              <RadioField
                                control={control}
                                name="Onco"
                                dataArray={OncoType}
                              />
                            </div>
                            <div>
                              <InputField
                                control={control}
                                name="percentage"
                                label="%"
                                sx={{ width: "100px" }}
                              />
                            </div>
                          </div>

                          <div className="grid grid-cols-2 gap-2">
                            <div>
                              <InputField
                                control={control}
                                name="pediatricStrength"
                                label="Pediatric Strength"
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="pediatricStrengths"
                              />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-2">
                            <div>
                              <InputField
                                control={control}
                                name="adultStrength"
                                label="Adult Strength"
                              />
                            </div>
                            <div>
                              <DropdownField
                                control={control}
                                name="adultStrengths"
                              />
                            </div>
                          </div>

                          <div className="lg:col-span-4 md:col-span-4 grid grid-cols-3 md:grid-cols-3 gap-3 items-center">
                            <div className="border border-slate-300 rounded flex justify-center">
                              <div>
                                <RadioField
                                  control={control}
                                  name="alphabet"
                                  dataArray={alphabetType}
                                />
                              </div>
                            </div>

                            <div className="border border-slate-300 px-3 rounded flex justify-center ">
                              <RadioField
                                control={control}
                                name="alphabetVED"
                                dataArray={alphabetTypeVED}
                              />
                            </div>
                            <div className="border border-slate-300 px-3 rounded flex justify-center ">
                              <RadioField
                                control={control}
                                name="alphabetXYZ"
                                dataArray={alphabetTypeXYZ}
                              />
                            </div>
                          </div>

                          <div className=" lg:col-span-4 md:col-span-4 flex gap-10 2xl:whitespace-nowrap">
                            <div>
                              <CheckBoxField
                                control={control}
                                label="Is Fixed Asset"
                                name="isFixedAsset"
                              />
                              {/* <CheckBoxField
                                control={control}
                                label="Is Fixed Asset"
                                name="isFixedAsset"
                              /> */}
                              <CheckBoxField
                                control={control}
                                label="Free Applicable"
                                name="freeApplicable"
                              />

                              <CheckBoxField
                                control={control}
                                label="Is CSSD"
                                name="isCSSD"
                              />
                              <CheckBoxField
                                control={control}
                                label="Is Concession Applicable"
                                name="isConcessionApplicable"
                              />
                              <CheckBoxField
                                control={control}
                                label="Is Culture"
                                name="isCulture"
                              />
                              <CheckBoxField
                                control={control}
                                label="Is Generic"
                                name="isGeneric"
                              />
                              <CheckBoxField
                                control={control}
                                label="Barcode Print"
                                name="barcodePrint"
                              />
                              <CheckBoxField
                                control={control}
                                label="Inclusive"
                                name="inclusive"
                              />
                            </div>
                          </div>
                          <div className="col-span-3 grid lg:grid-cols-2 md:grid-cols-1 2xl:grid-cols-2  ml-2">
                            <div className="">
                              <RadioField
                                control={control}
                                name="charge"
                                dataArray={chargeType}
                              />
                            </div>
                            <div>
                              <RadioField
                                control={control}
                                name="antibiotics"
                                dataArray={antibioticsType}
                              />
                            </div>
                          </div>
                        </div>
                      </Accordion>
                    </div>
                  </fieldset>
                </div>

                <fieldset>
                  <div className="w-full my-1 pb-2">
                    <Accordion
                      className="px-2  "
                      sx={{
                        "& .MuiAccordionSummary-root": {
                          padding: "0px",
                          // marginBottom: "-1rem",
                        },

                        "& .MuiAccordionDetails-root": {
                          padding: "0px",
                        },
                        boxShadow: 1,
                        paddingBottom: 2
                      }}
                      defaultExpanded={true}
                    >
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={
                          <ExpandMoreIcon
                          // sx={{
                          //   background: "#0B83A5",
                          //   margin: "5px 0",
                          //   color: "white",
                          //   minHeight: 0,
                          // }}
                          />
                        }
                        sx={{
                          "&.Mui-expanded": {
                            minHeight: 1,
                          },
                          "& .MuiAccordionSummary-content.Mui-expanded": {
                            margin: "auto",
                          },
                          "&.expanded": {
                            margin: "0px",
                          },
                        }}
                      >
                        <div>
                          <p className="text-start text-[16px] font-semibold py-2">
                            Description
                          </p>
                        </div>
                      </AccordionSummary>
                      <div className="grid grid-cols-3 md:grid-cols-3 gap-2 pb-2">
                        <div>
                          <InputField
                            control={control}
                            name="description"
                            label="Description"
                          />
                        </div>
                        <div>
                          <input
                            type="file"
                            ref={fileRef}
                            onChange={(e) => setSelectedFile(e.target.files[0])}
                          />
                        </div>
                        <div>
                          <CommonButton
                            label="Add"
                            className="bg-green-500 text-white"
                            type="button"
                            onClick={handleAdd}
                          />
                        </div>
                      </div>

                      {tableData.length > 0 && (
                        <table className="w-full mt-3 border-collapse">
                          <thead>
                            <tr className="bg-gray-100 text-gray-600 font-semibold">
                              <th className="py-1 px-2 text-left border-b">Action</th>
                              <th className="py-1 px-2 text-left border-b">Description</th>
                              <th className="py-1 px-2 text-left border-b">File Name</th>
                            </tr>
                          </thead>

                          <tbody>
                            {tableData.map((row, index) => (
                              <tr key={index} className="border-b">
                                <td className="py-1 px-2">
                                  <DeleteOutlineOutlinedIcon
                                    style={{ cursor: "pointer", color: "red" }}
                                    onClick={() =>
                                      setTableData(tableData.filter((_, i) => i !== index))
                                    }
                                  />
                                </td>
                                <td className="py-1 px-2">{row.description}</td>

                                <td className="py-1 px-2">{row.fileName}</td>

                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}

                    </Accordion>
                  </div>
                </fieldset>

                {props.edit === false ? (
                  <div className="flex justify-end gap-2 pt-2">
                    <CommonButton
                      label="Reset"
                      className=" border border-red-600 text-red-600"
                      type="button"
                    // onClick={() => reset(defaultValues)}
                    />
                    <CommonButton
                      label="Save"
                      className="bg-green-500 text-white"
                      type="Submit"
                      onClick={() => {
                        // handlElectricalDescriptionSubmit();
                      }}
                    />
                  </div>
                ) : (
                  <div className="flex justify-end gap-2 pt-2">
                    <CommonButton
                      label="Save"
                      className="bg-green-500 text-white"
                      type="Update"
                      onClick={() => {
                        // handlElectricalDescriptionSubmit();
                      }}
                    />
                  </div>
                )}
              </div>
            </fieldset>
          </form>

        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={handleClosePost}
        confirmationSubmitFunc={addRecord}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure you want to add this record ?"
        confirmationButtonMsg="Add"
      />
      <ConfirmationModal
        confirmationOpen={openPut}
        confirmationHandleClose={handleClosePut}
        confirmationSubmitFunc={addRecord}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure you want to update this record ?"
        confirmationButtonMsg="Update"
      />
    </div>
  );
}